import { AppMainSection } from '../../../model/app-main-section';
import appRoutes from '../../../routing/app-routes';

interface RouteSectionPair {
  route: string;
  section: AppMainSection;
}
const createRouteSectionPair = (
  route: string,
  section: AppMainSection
): RouteSectionPair => ({
  route,
  section,
});

const routeSectionPairs: RouteSectionPair[] = [
  createRouteSectionPair(appRoutes.Dashboard, 'home'),
  createRouteSectionPair(appRoutes.Wallet, 'wallet'),
  createRouteSectionPair(appRoutes.Sign, 'sign'),
  createRouteSectionPair(appRoutes.Documents, 'documents'),
  createRouteSectionPair(appRoutes.Others, 'others'),
  createRouteSectionPair(appRoutes.ForYou, 'for-you'),
  createRouteSectionPair(appRoutes.News, 'news'),
  createRouteSectionPair(appRoutes.ProfilePage, 'profile'),
  createRouteSectionPair(appRoutes.Faqs, 'faqs'),
  createRouteSectionPair(
    appRoutes.DetailPositionListPage,
    'detail-position-list'
  ),
  createRouteSectionPair(
    appRoutes.DetailTransactionsPage,
    'detail-transactions'
  ),
  createRouteSectionPair(appRoutes.DetailUnderlyingPage, 'detail-underlying'),
  createRouteSectionPair(appRoutes.DetailPerformancePage, 'detail-performance'),
];

const routeSectionMap = {
  routeForSection(section: AppMainSection): string | undefined {
    return routeSectionPairs.find((pair) => pair.section === section)?.route;
  },
  sectionForRoute(route: string): AppMainSection | undefined {
    if (route === appRoutes.DocumentContent) {
      return 'sign';
    }
    return routeSectionPairs.find((pair) => pair.route === route)?.section;
  },
};

export default routeSectionMap;
